import React from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";

const counters = [
  { label: "Captions Created", value: 7500 },
  { label: "Hashtags Generated", value: 25570 },
  { label: "App Downloads", value: 1700 },
];

export default function Counter() {
  return (
    <section
      id="counter"
      className="py-24 bg-gradient-to-tr from-indigo-50 via-white to-pink-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900"
    >
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-12">
          QuickCaptionIO in Numbers
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {counters.map((counter, idx) => (
            <motion.div
              key={idx}
              className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.8, delay: idx * 0.2 }}
            >
              <h3 className="text-4xl font-extrabold text-indigo-500 mb-2">
                <CountUp end={counter.value} duration={2.5} separator="," />
              </h3>
              <p className="text-slate-700 dark:text-slate-300">{counter.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
